export default __webpack_public_path__ + "static/media/zoom-in.c6f01189.svg";